import {convertBytesToHighestMeasurement} from "util/functions";
import alpaquitaSizes from "src/_download_tabs/alpaquita_sizes.json"
import alpaquitaImageSizes from "src/_download_tabs/alpaquita_image_sizes.json"

export const getAlpaquitaBinarySize = (href: string) => {
    const sizes: {[key: string]: number} = alpaquitaSizes
    return convertBytesToHighestMeasurement(sizes[href] || 0)
}

export const getAlpaquitaMuslImageSize = () => {
    return alpaquitaImageSizes["alpaquita-linux-base:stream-musl"];
}